<h1 style="text-align: center;">QCifris24 - Quantum Cifris 2024</h1>
<h2>Organizers</h2>
<p>

    <em>
        <b>Chair:</b> Paolo Villoresi (Università di Padova) <br>
        Marco Genovese (INRIM-Torino) <br>
        Fabio Sciarrino (Università di Roma La Sapienza) <br>
        Cristian Antonelli (Università dell’Aquila) <br>
        Giuseppe Vallone (Università di Padova)
    </em>
</p>
<h2>Description</h2>
<p>
    Countering the growing level of cybercrime requires an ever-innovative approach. Quantum
    Technologies propose solutions for cryptographic key exchange and random number generation
    that are radically new compared to the algorithmic approach, with which they can be integrated to
    achieve the highest levels of security.
    The state of the art and perspectives in this area will be presented. The status of quantum
    computing in cryptanalysis will also be presented.
</p>
<h2>Program</h2>
<p>
    <i> September 27th, workshop session</i>
    <br>
    <i> Room B, 11:40 - 13:00</i>
</p>
<table class="orari" cellspacing="2" cellpadding="2" id="27afternoon">
    <tr bgcolor="lightblue">
        <th class="schedule" colspan="2">
            <font size="+1"><b>September 27th (morning) - Workshop Session</b></font>
        </th>
    </tr>
    <tr>
        <td class="schedule">
            11:40
            11:50
        </td>
        <td>
            <i>
                <b>Paolo Villoresi</b>, University of Padova (Italy)
            </i>
            <br>
            Introduction to Quantum Technologies for secure information from an Italian perspective
            <details>
                <summary>
                    Abstract
                </summary>
                Italy has been active in the development of quantum communications protocols for more than
                two decades, with groups of researchers perfecting different techniques and fields of application.
                Quantum communication protocols are also complemented by research and development at a
                very advanced level in the areas of quantum meteorology, experimental components
                development and the establishment of a nationwide infrastructure to enable communication on a
                large scale. <br>
                In addition, our Country is also active in the research and development of quantum computing.
                This includes both a part of theoretical study of algorithms and is an experimental part for its
                implementation, in different platforms. Given the crucial significance of quantum computing in
                cyberattacks, this area is also of strategic importance in the field of cryptography.
            </details>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            11:50
            12:05
        </td>
        <td>
            <i>
                <b>Fabio Sciarrino</b>, University of Roma La Sapienza (Italy)
            </i>
            <br>
            Entanglement for quantum key distribution
            <details>
                <summary>
                    Abstract
                </summary>
                Quantum key distribution—exchanging a random secret key relying on a quantum mechanical
                resource—is the core feature of secure quantum networks. Entanglement-based protocols offer
                additional layers of security and scale favorably with quantum repeaters, but the stringent
                requirements set on the photon source have made their use situational so far. We will briefly
                review the current implementations of an entanglement-based quantum key distribution (QKD)
                protocol and the future perspectives.
            </details>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            12:05
            12:20
        </td>
        <td>
            <i>
                <b>Simone Montangero</b>, University of Padova (Italy)
            </i>
            <br>
            Quantum Computing in Cybersecurity
        </td>
    </tr>
    <tr>
        <td class="schedule">
            12:20
            12:35
        </td>
        <td>
            <i>
                <b>Giuseppe Vallone</b>, University of Padova (Italy)
            </i>
            <br>
            Genuine random numbers from quantum processes for cybersecurity
        </td>
    </tr>
    <tr>
        <td class="schedule">
            12:35
            13:00
        </td>
        <td>
            <i>
                <b>Tommaso Occhipinti</b>, QTI (Italy)
                <br>
                <b>Simone Capeleto</b>, ThinkQuantum SRL (Italy)
            </i>
            <br>
            National and European Quantum Communications for Enhanced Security: Technology and
            Applications
        </td>
    </tr>
</table>